export const getAccountImportExportSettingFormConfig = (defaultAccountFieldTypeValues, formFieldChildren, additionalFormFields, isTypeRequired) => {
    return {
        type: 'form',
        children: [
            {
                type: 'form.dataGrid',
                reorder: true,
                children: [
                    {
                        type: 'form.panel',
                        children: [
                            {
                                type: 'form.panel',
                                children: [
                                    {
                                        type: 'form.text',
                                        key: 'headerName',
                                        label: 'Header Name',
                                        validate: {
                                            required: true,
                                        },
                                    },
                                    ...formFieldChildren,
                                ],
                                style: {
                                    layout: 'row',
                                    horizontalAlign: 'left',
                                },
                            },
                            {
                                type: 'form.select',
                                key: 'type',
                                label: 'Type',
                                values: defaultAccountFieldTypeValues,
                                validate: {
                                    required: isTypeRequired,
                                },
                            },
                            ...(additionalFormFields !== null && additionalFormFields !== void 0 ? additionalFormFields : []),
                            {
                                type: 'form.divider',
                            },
                        ],
                    },
                ],
            },
        ],
    };
};
